<!-- Collapsed: magnifying-glass icon -->
<button
    *ngIf="!opened"
    (click)="open()"
    mat-icon-button
    matTooltip="Suche (Immobilien, Mieter)">
    <mat-icon [svgIcon]="'heroicons_outline:search'"></mat-icon>
</button>

<!-- Expanded: inline search bar + results panel -->
<div
    *ngIf="opened"
    @slideInTop
    class="flex items-center">
    <mat-form-field
        [subscriptSizing]="'dynamic'"
        class="fuse-mat-dense fuse-mat-rounded w-60 sm:w-80">
        <mat-icon
            matPrefix
            [svgIcon]="'heroicons_outline:search'"></mat-icon>
        <input
            #barSearchInput
            matInput
            [formControl]="searchControl"
            [matAutocomplete]="auto"
            [placeholder]="'Immobilien, Mieter…'"
            (keydown)="onKeydown($event)">
        <mat-progress-spinner
            *ngIf="loading"
            matSuffix
            [diameter]="18"
            [mode]="'indeterminate'"></mat-progress-spinner>
        <button
            *ngIf="!loading"
            matSuffix
            mat-icon-button
            (click)="close()">
            <mat-icon>close</mat-icon>
        </button>
    </mat-form-field>

    <mat-autocomplete
        #auto="matAutocomplete"
        [disableRipple]="true"
        (optionSelected)="onSelect($event.option.value)"
        class="global-search-panel max-h-128 mt-1 rounded">

        <!-- Sections (Mieter first when the query matches tenants) -->
        <mat-optgroup
            *ngFor="let section of orderedSections; trackBy: trackBySectionType"
            [label]="section.label">
            <mat-option
                *ngFor="let hit of section.hits; trackBy: trackByObjectID"
                [value]="{type: section.type, hit: hit}"
                class="text-md">
                <div class="flex flex-col leading-tight py-1">
                    <span class="font-medium truncate" [innerHTML]="titleHtml(section, hit)"></span>
                    <span
                        *ngIf="subtitleHtml(section, hit)"
                        class="text-sm text-secondary truncate"
                        [innerHTML]="subtitleHtml(section, hit)"></span>
                </div>
            </mat-option>
        </mat-optgroup>

        <!-- No results -->
        <mat-option
            *ngIf="!loading && !propertyHits?.length && !tenantHits?.length && searchControl.value?.trim()?.length >= minLength"
            [disabled]="true"
            class="text-md text-secondary">
            Keine Ergebnisse
        </mat-option>
    </mat-autocomplete>
</div>
